// 1. Function to find and remove the space within the specific parent block
function fixPriceSpacing() {
    // Target the main wrapper block by ID
    const rootBlock = document.getElementById('key_options_block');
    
    // If the block isn't on the page yet, stop and wait for the observer
    if (!rootBlock) return;

    // Use a TreeWalker to efficiently find all text nodes within this specific block
    const walker = document.createTreeWalker(
        rootBlock,
        NodeFilter.SHOW_TEXT,
        null,
        false
    );

    let node;
    // Loop through every text node inside the block
    while ((node = walker.nextNode())) {
        const originalText = node.nodeValue;
        
        // If the text contains a $ followed by a space and a number
        if (/\$\s+(?=\d)/.test(originalText)) {
            // Replace the '$ ' with just '$'
            node.nodeValue = originalText.replace(/\$\s+(?=\d)/g, '$');
        }
    }
}

// 2. Set up the MutationObserver to watch for dynamic changes
const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0 || mutation.type === 'characterData') {
            shouldRun = true;
            break;
        }
    }
    
    if (shouldRun) {
        // Disconnect briefly to prevent an infinite loop when we change the text
        observer.disconnect();
        
        fixPriceSpacing();
        
        // Reconnect immediately after. We observe the body in case the key_options_block 
        // itself is injected dynamically after the initial page load.
        observer.observe(document.body, { 
            childList: true, 
            subtree: true, 
            characterData: true 
        });
    }
});

// 3. Start observing the document body
observer.observe(document.body, { 
    childList: true, 
    subtree: true, 
    characterData: true 
});

// 4. Run once on initial load
document.addEventListener("DOMContentLoaded", fixPriceSpacing);